<template>
  <div class="diagnosis-bg">
    <canvas ref="particlesCanvas" id="diagnosis-particles"></canvas>
    <div class="diagnosis-grid-bg"></div>
    <div class="diagnosis-scanline"></div>
  </div>
</template>

<script>
/**
 * 背景动画组件 — Canvas粒子 + 网格 + 扫描线
 * 1:1 复刻原HTML粒子系统
 */
export default {
  name: 'DiagnosisBackground',
  data() {
    return {
      particles: [],
      mouseX: -1000,
      mouseY: -1000,
      animFrameId: null
    }
  },
  mounted() {
    this.initParticles()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.animFrameId) cancelAnimationFrame(this.animFrameId)
  },
  methods: {
    initParticles() {
      const canvas = this.$refs.particlesCanvas
      if (!canvas) return
      const ctx = canvas.getContext('2d')
      let w = canvas.width = window.innerWidth
      let h = canvas.height = window.innerHeight

      this.particles = []
      for (let i = 0; i < 100; i++) {
        this.particles.push({
          x: Math.random() * w,
          y: Math.random() * h,
          vx: (Math.random() - 0.5) * 0.5,
          vy: (Math.random() - 0.5) * 0.5,
          size: Math.random() * 1.2 + 0.4,
          opacity: Math.random() * 0.4 + 0.1
        })
      }

      const animate = () => {
        ctx.clearRect(0, 0, w, h)
        const ps = this.particles

        for (let i = 0; i < ps.length; i++) {
          const p = ps[i]
          p.x += p.vx
          p.y += p.vy

          const dx = this.mouseX - p.x
          const dy = this.mouseY - p.y
          const dist = Math.sqrt(dx * dx + dy * dy)
          if (dist < 180 && dist > 1) {
            const f = 0.008
            p.vx += (dx / dist) * f
            p.vy += (dy / dist) * f
          }

          p.vx *= 0.999
          p.vy *= 0.999
          if (p.x < -50) p.x = w + 50
          if (p.x > w + 50) p.x = -50
          if (p.y < -50) p.y = h + 50
          if (p.y > h + 50) p.y = -50

          ctx.beginPath()
          ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2)
          ctx.fillStyle = `rgba(0, 212, 255, ${p.opacity})`
          ctx.fill()
        }

        // 连线
        for (let i = 0; i < ps.length; i++) {
          for (let j = i + 1; j < ps.length; j++) {
            const dx = ps[i].x - ps[j].x
            const dy = ps[i].y - ps[j].y
            const dist = Math.sqrt(dx * dx + dy * dy)
            if (dist < 130) {
              const alpha = (1 - dist / 130) * 0.08
              ctx.beginPath()
              ctx.moveTo(ps[i].x, ps[i].y)
              ctx.lineTo(ps[j].x, ps[j].y)
              ctx.strokeStyle = `rgba(0, 212, 255, ${alpha})`
              ctx.lineWidth = 0.4
              ctx.stroke()
            }
          }
        }

        this.animFrameId = requestAnimationFrame(animate)
      }

      animate()

      // 鼠标跟踪
      this._mouseHandler = (e) => {
        this.mouseX = e.clientX
        this.mouseY = e.clientY
      }
      window.addEventListener('mousemove', this._mouseHandler)
    },

    handleResize() {
      const canvas = this.$refs.particlesCanvas
      if (canvas) {
        canvas.width = window.innerWidth
        canvas.height = window.innerHeight
      }
    }
  }
}
</script>
